import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ENTITY_ADD_REQUESTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('ENTITY_ADD_REQUESTS');
export const ENTITY_ADD_REQUESTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ENTITY_ADD_REQUESTS_CRUD_ACTION_CONSTANTS
);
